export default __webpack_public_path__ + "static/media/unitasHero.bb47c43d.png";